import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface GradeActivityAnswerMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
  input: {
    score?: string;
    feedback?: {
      text?: string;
      file?: {
        name: string;
        path: string;
      };
    };
  };
}

export interface GradeActivityAnswerMutationResult {
  answer: ProfessorActivityAnswer;
}

export const gradeActivityAnswerMutation = gql`
  mutation GradeActivityAnswerMutation($courseId: String!, $activityId: String!, $answerId: String!, $input: GradeActivityAnswerMutationInput!) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId, input: $input)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}/grade", method: "PUT") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
